import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { DataSourceResponse, InsuranceCompany } from '../../models';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class InsuranceCompanyService extends ApiService {
  endPoint = '/api/insuranceCompanies';

  create(model: InsuranceCompany) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: InsuranceCompany) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<InsuranceCompany> {
    return this.http.get<InsuranceCompany>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<InsuranceCompany>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}
